export default {
    "name": "InitialCustomerPageLoad",
    "kind": "HoudiniQuery",
    "hash": "b422ed1c24c73ec909ba129706552353d3fc5361be07870a74c78f80e053a6ea",

    "raw": `query InitialCustomerPageLoad($filter: UserAccountFilter) {
  states {
    country
    stateAbbreviation
    stateCode
    stateName
  }
  paymentMethods {
    id
    name
  }
  userAccounts(filter: $filter) {
    id
    name
  }
  taxItems {
    id
    name
  }
  salesOrderTerms {
    id
    name
    code
    customerMemo
  }
  stores {
    id
    name
  }
  customerTypes
  settingValues {
    api {
      addressServiceEnabled
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "states": {
                "type": "State",
                "keyRaw": "states",

                "selection": {
                    "fields": {
                        "country": {
                            "type": "String",
                            "keyRaw": "country",
                            "nullable": true,
                            "visible": true
                        },

                        "stateAbbreviation": {
                            "type": "String",
                            "keyRaw": "stateAbbreviation",
                            "nullable": true,
                            "visible": true
                        },

                        "stateCode": {
                            "type": "Int",
                            "keyRaw": "stateCode",
                            "nullable": true,
                            "visible": true
                        },

                        "stateName": {
                            "type": "String",
                            "keyRaw": "stateName",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "paymentMethods": {
                "type": "PaymentMethod",
                "keyRaw": "paymentMethods",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "userAccounts": {
                "type": "UserAccount",
                "keyRaw": "userAccounts(filter: $filter)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "taxItems": {
                "type": "TaxItem",
                "keyRaw": "taxItems",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "salesOrderTerms": {
                "type": "Term",
                "keyRaw": "salesOrderTerms",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true,
                            "nullable": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "code": {
                            "type": "String",
                            "keyRaw": "code",
                            "visible": true
                        },

                        "customerMemo": {
                            "type": "String",
                            "keyRaw": "customerMemo",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "stores": {
                "type": "Store",
                "keyRaw": "stores",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "customerTypes": {
                "type": "String",
                "keyRaw": "customerTypes",
                "visible": true
            },

            "settingValues": {
                "type": "SettingValues",
                "keyRaw": "settingValues",

                "selection": {
                    "fields": {
                        "api": {
                            "type": "ApiConfigSettingValues",
                            "keyRaw": "api",

                            "selection": {
                                "fields": {
                                    "addressServiceEnabled": {
                                        "type": "Boolean",
                                        "keyRaw": "addressServiceEnabled",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "filter": "UserAccountFilter"
        },

        "types": {
            "UserAccountFilter": {
                "authorizedStores": "UInt",
                "id": "UInt",
                "isSalesPerson": "Boolean",
                "name": "String",
                "status": "UserAccountStatusEnum"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=25445fb256ebc3a709c005f5be7e38630f2ccb06bc9be460883d80f88025abd5";